import { render, staticRenderFns } from "./PayConfig.vue?vue&type=template&id=fb6eeb22&"
import script from "./PayConfig.vue?vue&type=script&lang=js&"
export * from "./PayConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports